import { render, staticRenderFns } from "./BuyersSection.vue?vue&type=template&id=083941e0"
import script from "./BuyersSection.vue?vue&type=script&lang=js"
export * from "./BuyersSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports